import React from 'react';
import PropTypes from 'prop-types';
import { getTranslatedText } from '../../../helper/get_translated_text';
import { Price } from './price';
import { RowTwoCells } from './row_two_cells';
import { Label } from './shipping_price/label';
import Tooltip from '../../tooltip/tooltip';
import { Translation } from '../../translation/translation';
import { getTranslationKeyByShippingTime } from '../../../../_modules/shipping/translationKey/get_translation_key_by_shipping_time';
import { SHORT_TRANSLATION_KEY } from '../../../../_modules/shipping/translationKey/constants';
import { pushConditionally } from '../../../../_modules/array/push_conditionally';

function ShippingPriceIncludesLabel(props) {
    let hasAdditional = false;
    let translationKey = 'pdp-sidebar-shipping-price';

    if (props.hasAccessories) {
        translationKey += '-incl-accessories';
        hasAdditional = true;
    }

    if (props.hasWheels) {
        translationKey += '-incl-wheels';
        hasAdditional = true;
    }

    if (props.hasTools) {
        translationKey += '-incl-tools';
        hasAdditional = true;
    }

    if (!hasAdditional) {
        return null;
    }

    return (
        <Translation
            className="shipping-price__includes"
            translationKey="translationKey"
        />
    );
}

ShippingPriceIncludesLabel.propTypes = {
    hasAccessories: PropTypes.bool.isRequired,
    hasWheels: PropTypes.bool.isRequired,
    hasTools: PropTypes.bool.isRequired,
};

export function ShippingPrice({
    shippingPrice,
    shippingTime,
    currencyIsoCode,
    hasAccessories,
    loading,
    hasWheels,
    hasTools,
    allowChangeShipping,
    isMobileFitter,
    sidebarPostcode,
    fromAddress,
    fromDetails,
    fromCart,
    onCalculateClick,
    onShowProductDetailsClick,
}) {
    let label = getTranslatedText('pdp-sidebar-shipping-price');
    const labelExtraChildrenWithShippingTime = pushConditionally(
        [
            !!fromAddress
            ? (<span style={{ marginLeft: '5px' }}>
                <>from&nbsp;{fromAddress}</>
            </span>)
            : <span></span>,
            (<span style={{ marginLeft: '5px' }}>
                {
                    sidebarPostcode
                        ? <>to&nbsp;
                            {(isMobileFitter
                                ? sidebarPostcode.substring(0, sidebarPostcode.lastIndexOf(','))
                                : sidebarPostcode)}</>
                        : ''
                }
            </span>),
            <br
                key="ShippingTimeLabelBr"
            />,
            <Tooltip
                label={
                    getTranslatedText(
                        getTranslationKeyByShippingTime(shippingTime, SHORT_TRANSLATION_KEY),
                        { duration: shippingTime }
                    )
                }
                content={getTranslatedText('cart-shipping-note')}
                additionalClassNames={['shipping-price__estimation']}
                key="ShippingTimeToolTip"
            />,
        ],
        shippingTime,
        []
    );

    const labelExtraChildrenWithChangeLink = pushConditionally(
        [
            <br
                key="ShippingTimeChangeLinkLabelBr"
            />,
            <Translation
                translationKey="sidebar-shipping-change-postcode"
                onClick={onCalculateClick}
                className="shipping-price__change-shipping-postcode"
                key="ShippingTimeChangePostcode"
            />,
        ],
        shippingTime && allowChangeShipping,
        !fromCart ? labelExtraChildrenWithShippingTime : []
    );

    let labelExtraChildren = [
        ...labelExtraChildrenWithChangeLink,
        <br
            key="ShippingPriceIncludesLabelBr"
        />,
        <ShippingPriceIncludesLabel
            hasAccessories={hasAccessories}
            hasWheels={hasWheels}
            hasTools={hasTools}
            key="ShippingPriceIncludesLabel"
        />
    ];

    if (fromCart) {
        label = getTranslatedText('cart-sidebar-shipping-totals');
        labelExtraChildren = [
            ...labelExtraChildren,
            <div className='underline cursor-pointer' onClick={onShowProductDetailsClick}>{getTranslatedText('cart-sidebar-shipping-delivery-details')}</div>
        ];
        return (
            <Price
                name={`shipping-price ${fromDetails ? 'sidebar__row--no-border font-weight-light' : ''}`}
                label={label}
                price={shippingPrice}
                labelExtraChildren={labelExtraChildren}
                loading={loading}
                currencyIsoCode={currencyIsoCode}
                middle={false}
                colspan={2}
            />
        );
    }
    
    if (shippingPrice !== -1) {
        return (
            <Price
                name={`shipping-price ${fromDetails ? 'sidebar__row--no-border font-weight-light' : ''}`}
                label={label}
                price={shippingPrice}
                labelExtraChildren={labelExtraChildren}
                loading={loading}
                currencyIsoCode={currencyIsoCode}
                middle={false}
                colspan={2}
            />
        );
    }

    return (
        <RowTwoCells
            name="shipping-price"
            left={(
                <Label
                    name="shipping-price"
                    label={label}
                />
            )}
            right={(
                <Translation
                    className="shipping-price__calculate"
                    onClick={onCalculateClick}
                    translationKey="shipping-calc-calculate"
                />
            )}
            middle={false}
            colspan={2}
        />
    );
}

ShippingPrice.propTypes = {
    shippingPrice: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    sidebarPostcode: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    hasAccessories: PropTypes.bool,
    isMobileFitter: PropTypes.bool,
    hasWheels: PropTypes.bool,
    hasTools: PropTypes.bool,
    allowChangeShipping: PropTypes.bool,
    onCalculateClick: PropTypes.func.isRequired,
};

ShippingPrice.defaultProps = {
    hasAccessories: false,
    hasWheels: false,
    hasTools: false,
    allowChangeShipping: false,
};
